import React, { useState, useEffect, useMemo } from 'react'
import Wrapper from '../../components/Wrapper'
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'
import { Paper, Box, Typography, IconButton, Alert, TextField, Grid, Button, Select, MenuItem, FormControl, InputLabel, FormControlLabel, Checkbox, Tooltip } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import InfoIcon from '@mui/icons-material/Info'
import { did, global, included, input, menu, profile, sip, employee, short, lang, group } from '../../translate'
import { toast } from 'react-toastify'
import { 
  greenTheme,
  sectionTitleStyles,
  captionTypographyStyles,
  profileDividerBoxStyles,
  profileSectionTitleStyles,
} from '../../helpers/style'
import Api from '../../Api'
import SelectReact from 'react-select'
import { customStyles } from '../../helpers/style'
import Cookies from 'js-cookie'
import { useSelector } from 'react-redux'

const { REACT_APP_SERVER } = process.env
const primaryColor = REACT_APP_SERVER === 'ATS' ? '#0b73b9' : greenTheme.primary
const hoverColor = REACT_APP_SERVER === 'ATS' ? '#095a8f' : greenTheme.hover
const inputStylesLocal = {
  '& .MuiOutlinedInput-root': { minHeight: '41px', '& fieldset': { borderColor: primaryColor }, '&:hover fieldset': { borderColor: hoverColor }, '&.Mui-focused fieldset': { borderColor: primaryColor } },
  '& .MuiInputLabel-root.Mui-focused': { color: primaryColor },
}
const inputLabelStylesLocal = { '&.Mui-focused': { color: primaryColor } }
const selectStylesLocal = {
  '& .MuiOutlinedInput-root': { minHeight: '41px' },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: primaryColor },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: hoverColor },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: primaryColor },
}
const checkboxStylesLocal = {
  color: primaryColor,
  '&.Mui-checked': { color: primaryColor },
}
const customStylesLocal = {
  ...customStyles,
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? primaryColor : base.borderColor,
    boxShadow: state.isFocused ? `0 0 0 1px ${primaryColor}` : base.boxShadow,
    '&:hover': { borderColor: primaryColor },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: (state.isSelected || state.isFocused) ? `${primaryColor}26` : base.backgroundColor,
    color: '#000',
    border: 'none',
    borderTop: 'none',
    borderBottom: 'none',
    outline: 'none',
    WebkitTapHighlightColor: 'transparent',
  }),
}

export default function DidSingle() {
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const langIndex = +localStorage.getItem('atsLang') || 1
  const [saving, setSaving] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({
    operator: '',
    note: '',
    ord: 1,
    caller_visible_type: 0,
    no_action: '',
    phone: '',
    profile: '',
    serverHost: '',
    username: '',
    password: '',
    forward: '',
    line: '1'
  })
  const [shorts, setShorts] = useState([])
  const [employees, setEmployees] = useState([])
  const [shortFunctionCodes, setShortFunctionCodes] = useState([])
  const [shortGroups, setShortGroups] = useState([])
  const [providers, setProviders] = useState([])
  const [fixProviders, setFixProviders] = useState([])
  const userData = useSelector((state) => state.users.userData)
  const [isEdit, setIsEdit] = useState(false)
  const [isTel, setIsTel] = useState(false)
  const [profileSelectOpen, setProfileSelectOpen] = useState(false)
  const isAdmGroup5 = String(userData?.admgroup) === '5'
  const admGroup5Providers = providers.filter((p) => [, '6',].includes(String(p.name)))

  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true)
      try {
        const [shortResponse, employeesRes, shortNumbersRes, groupsResponse, providerResponse] = await Promise.all([
          Api.shortForVirtual(),
          Api.employeeGetEmployees().catch(() => ({ data: { employees: [] } })),
          Api.shortGetShortNumbers().catch(() => ({ data: { data: [] } })),
          Api.groupsGet(1).catch(() => ({ data: {} })),
          Api.getCreateDid()
        ])
        setShorts(shortResponse?.data?.short || [])
        setEmployees(employeesRes?.data?.employees || [])
        const fnList = shortNumbersRes?.data?.data || []
        setShortFunctionCodes(fnList.map((l) => {
          const code = String(l.function_code ?? l.code ?? '')
          return { value: code, label: l[lang[langIndex]] || l[lang[1]] || code }
        }))
        if (groupsResponse?.data?.status === 'ok') {
          setShortGroups(groupsResponse.data.data || [])
        } else {
          setShortGroups([])
        }
        setProviders(providerResponse?.data?.inputNumber?.provider || [])
        setFixProviders(providerResponse?.data?.inputNumber?.fix_provider || [])

        const phone = searchParams.get('phone')
        const provider = searchParams.get('provider')

        if (phone && provider) {
          setIsEdit(true)
          const { data } = await Api.singleDid(phone, provider)
          if (+data?.did?.redirect?.provider === 45) {
            setIsTel(true)
          } else {
            setIsTel(false)
          }

          setForm({
            operator: data?.did?.provider || '',
            note: data?.did?.notes || '',
            ord: data?.did?.ord !== undefined ? data?.did?.ord : 1,
            caller_visible_type: data?.did?.caller_visible_type ? 1 : 0,
            no_action: data?.did?.no_action || '',
            phone: (data?.did?.pref || '') + (data?.did?.did || ''),
            profile: data?.did?.redirect?.provider || '',
            serverHost: data?.did?.redirect?.server_host || '',
            username: data?.did?.redirect?.username || '',
            password: data?.did?.redirect?.password || '',
            forward: data?.did?.output?.output || '',
            line: data?.did?.dlines || '1'
          })
        } else if (id && id !== 'add') {
          setIsEdit(true)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        toast.error('Error loading Main number data')
      } finally {
        setLoading(false)
      }
    }

    fetchInitialData()
  }, [id, searchParams])

  const noActionGroupedOptions = useMemo(() => {
    const emptyOption = { value: '', label: input.select[langIndex] }
    const fnOptions = shortFunctionCodes.filter((fc) => fc.value)
    const groupOpts = shortGroups.filter((g) => g.isivr === 0).map((g) => ({
      value: g.virtual,
      label: `${g.virtual} (${g.name || ''})`
    }))
    const ivrOpts = shortGroups.filter((g) => g.isivr === 1).map((g) => ({
      value: g.virtual,
      label: `${g.virtual} (${g.name || ''})`
    }))
    return [
      { label: short.no_answer[langIndex], options: [emptyOption, ...fnOptions] },
      ...(groupOpts.length ? [{ label: short.group[langIndex], options: groupOpts }] : []),
      ...(ivrOpts.length ? [{ label: short.ivr_lists[langIndex], options: ivrOpts }] : [])
    ]
  }, [shortFunctionCodes, shortGroups, langIndex])

  const noActionValueOption = useMemo(() => {
    const na = form.no_action
    if (na === '' || na === null || na === undefined) return null
    const str = String(na)
    const fromFn = shortFunctionCodes.find((fc) => fc.value === str)
    if (fromFn) return fromFn
    const fromGroup = shortGroups.find((g) => String(g.virtual) === str)
    if (fromGroup) return { value: fromGroup.virtual, label: `${fromGroup.virtual} (${fromGroup.name || ''})` }
    return { value: na, label: str }
  }, [form.no_action, shortFunctionCodes, shortGroups])

  const forwardGroupedOptions = useMemo(() => {
    const emptyOption = { value: '', label: input.select[langIndex] }
    const fnOptions = shortFunctionCodes.filter((fc) => fc.value)
    const employeeOpts = (employees || []).map((e) => ({
      value: String(e.buddy ?? e.id ?? ''),
      label: `${e.buddy ?? e.id ?? ''}${e.notes || e.name ? ` (${e.notes || e.name})` : ''}`,
    })).filter((o) => o.value)
    const groupOpts = shortGroups.filter((g) => g.isivr === 0).map((g) => ({
      value: String(g.virtual),
      label: `${g.virtual} (${g.name || ''})`,
    }))
    const ivrOpts = shortGroups.filter((g) => g.isivr === 1).map((g) => ({
      value: String(g.virtual),
      label: `${g.virtual} (${g.name || ''})`,
    }))
    return [
      { label: short.no_answer[langIndex], options: [emptyOption, ...fnOptions] },
      ...(employeeOpts.length ? [{ label: group.employee_section?.[langIndex] || 'Employees', options: employeeOpts }] : []),
      ...(groupOpts.length ? [{ label: short.group[langIndex], options: groupOpts }] : []),
      ...(ivrOpts.length ? [{ label: short.ivr_lists[langIndex], options: ivrOpts }] : []),
    ]
  }, [shortFunctionCodes, shortGroups, employees, langIndex])

  const forwardValueOption = useMemo(() => {
    const fv = form.forward
    if (fv === '' || fv === null || fv === undefined) return null
    const str = String(fv)
    const fromFn = shortFunctionCodes.find((fc) => fc.value === str)
    if (fromFn) return fromFn
    const fromEmp = (employees || []).find((e) => String(e.buddy ?? e.id ?? '') === str)
    if (fromEmp) {
      return {
        value: str,
        label: `${fromEmp.buddy ?? fromEmp.id ?? ''}${fromEmp.notes || fromEmp.name ? ` (${fromEmp.notes || fromEmp.name})` : ''}`,
      }
    }
    const fromGroup = shortGroups.find((g) => String(g.virtual) === str)
    if (fromGroup) return { value: fromGroup.virtual, label: `${fromGroup.virtual} (${fromGroup.name || ''})` }
    return { value: fv, label: str }
  }, [form.forward, shortFunctionCodes, shortGroups, employees])

  const handleChange = (name, value) => {
    if (name === 'operator' && value === '1') {
      setProfileSelectOpen(false)
      setForm(prev => ({
        ...prev,
        operator: value,
        phone: '374',
        profile: ''
      }))
    } else if (name === 'operator' && value === '2') {
      setProfileSelectOpen(true)
      setForm(prev => ({
        ...prev,
        operator: value,
        phone: '',
        profile: ''
      }))
    } else if (name === 'operator' && value === '3') {
      setProfileSelectOpen(false)
      setForm(prev => ({
        ...prev,
        operator: value,
        profile: '45',
        serverHost: 'sip.tg',
        phone: ''
      }))
    } else if (name === 'operator') {
      setProfileSelectOpen(String(value) === '2')
      setForm(prev => ({
        ...prev,
        operator: value,
        profile: String(value) === '2' ? '' : prev.profile,
      }))
    } else if (name === 'profile') {
      setProfileSelectOpen(false)
      setForm(prev => ({
        ...prev,
        [name]: value
      }))
    } else {
      setForm(prev => ({
        ...prev,
        [name]: value
      }))
    }
  }

  const handleWheel = (event) => {
    event.target.blur()
    event.preventDefault()
  }

  const handleGoBack = () => {
    navigate('/main_number')
  }

  const handleSave = async () => {
    if (!form.operator) {
      toast.error(did.operator[langIndex] + ' ' + (input.is_req?.[langIndex] || 'is required'))
      return
    }
    const nameTrim = String(form.note || '').trim()
    if (!nameTrim) {
      toast.error(employee.name_label[langIndex] + ' ' + (input.is_req?.[langIndex] || 'is required'))
      return
    }
    if (!form.phone) {
      toast.error(included.phone[langIndex] + ' ' + (input.is_req?.[langIndex] || 'is required'))
      return
    }

    setSaving(true)
    try {
      if (isEdit) {
        const provider = searchParams.get('provider') || form.profile
        await Api.editDid(form, provider)
        toast.success(global.edit[langIndex] + ' ' + global.success[langIndex])
        navigate('/main_number')
      } else {
        await Api.createDid(form)
        toast.success(sip.add_btn[langIndex] + ' ' + global.success[langIndex])
        navigate('/main_number')
      }
    } catch (error) {
      console.error('Error saving Main number:', error)
      toast.error(isEdit ? 'Failed to save changes' : 'Failed to create Main number')
    } finally {
      setSaving(false)
    }
  }

  const isUcomPeer = String(form.operator) === '2'
  const shouldShowProfileFields = isUcomPeer || isEdit
  const shouldShowCredentialFields = form.profile && +form.profile !== 45
  const showServerHost = form.profile && (+form.profile === 27 || +form.profile === 42)

  useEffect(() => {
    if (isUcomPeer && !isEdit) {
      setProfileSelectOpen(true)
    }
  }, [isUcomPeer, isEdit])

  return (
    <Wrapper>
      <div className="tableParent">
        <Paper sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
            <IconButton
              size="small"
              sx={{ color: primaryColor, fontSize: 18, '&:hover': { backgroundColor: `${primaryColor}15` } }}
              onClick={handleGoBack}
              aria-label="Back"
            >
              <ArrowBackIosNewIcon sx={{ fontSize: 20, fontWeight: 700 }} />
            </IconButton>
            <Typography variant="h5" sx={{ fontWeight: 700, m: 0 }}>
              {menu.did[langIndex]}
            </Typography>
          </Box>

          <Alert
            icon={<InfoIcon />}
            severity="success"
            sx={
              REACT_APP_SERVER !== 'ATS'
                ? { mb: 3 }
                : {
                  mb: 3,
                  border: `1px solid ${primaryColor}`,
                  backgroundColor: `${primaryColor}10`,
                  '& .MuiAlert-icon': { color: primaryColor },
                }
            }
          >
            <Typography variant="body2">
              {did.create[langIndex]}
            </Typography>
          </Alert>

          <Paper sx={{ p: 3, border: `1px solid ${primaryColor}` }}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={sectionTitleStyles}>
                {did.did[langIndex]}
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth size="small" sx={selectStylesLocal} required>
                    <InputLabel sx={inputLabelStylesLocal}>{did.operator[langIndex]}</InputLabel>
                    <Select
                      value={form.operator}
                      onChange={(e) => handleChange('operator', e.target.value)}
                      disabled={isEdit}
                      label={did.operator[langIndex]}
                    >
                      <MenuItem value="">{input.select[langIndex]}</MenuItem>
                      {isAdmGroup5 ? (
                        admGroup5Providers.map((p) => (
                          <MenuItem key={p.name} value={p.name}>{p.title}</MenuItem>
                        ))
                      ) : (
                        (Cookies.get('viewer') && Cookies.get('original') || isEdit) ? (
                          (isEdit
                            ? providers
                            : providers.filter((d) => d.name !== 3 && d.name !== 4 && d.name !== 7)
                          ).map((p) => (
                            <MenuItem key={p.name} value={p.name}>{p.title}</MenuItem>
                          ))
                        ) : (
                          [
                            ...(!(Cookies.get('viewer') && Cookies.get('original'))
                              ? [<MenuItem key="ucom" value="2">Ucom Peer</MenuItem>]
                              : []),
                          ]
                        )
                      )}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label={included.phone[langIndex]}
                    placeholder={included.phone[langIndex]}
                    value={form.phone}
                    onChange={(e) => handleChange('phone', e.target.value)}
                    disabled={isEdit}
                    required
                    sx={inputStylesLocal}
                    helperText={+form.profile === 45 ? form.username : ''}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography variant="caption" sx={captionTypographyStyles}>
                      {sip.forward[langIndex]}
                    </Typography>
                    <SelectReact
                      styles={{
                        ...customStylesLocal,
                        groupHeading: (base, props) => {
                          if (props?.data?.label === short.no_answer[langIndex]) {
                            return { ...base, display: 'none', padding: 0, margin: 0, height: 0, minHeight: 0, overflow: 'hidden' }
                          }
                          return {
                            ...base,
                            fontSize: '1rem',
                            fontWeight: 600,
                            lineHeight: '40px',
                            color: '#424242',
                            backgroundColor: '#e8e8e8',
                            padding: '0 12px',
                          }
                        },
                      }}
                      menuPlacement="auto"
                      menuPosition="fixed"
                      onChange={(option) => handleChange('forward', option ? option.value : '')}
                      menuPortalTarget={document.body}
                      isSearchable={true}
                      value={forwardValueOption}
                      placeholder={input.select[langIndex]}
                      options={forwardGroupedOptions}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label={employee.name_label[langIndex]}
                    placeholder={employee.name_placeholder[langIndex]}
                    value={form.note}
                    onChange={(e) => handleChange('note', e.target.value)}
                    variant="outlined"
                    required
                    sx={inputStylesLocal}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Tooltip title={did.visibleExplain[langIndex]} arrow>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!form.caller_visible_type}
                            onChange={(e) => handleChange('caller_visible_type', e.target.checked ? 1 : 0)}
                            sx={checkboxStylesLocal}
                          />
                        }
                        label={did.visible[langIndex]}
                      />
                    </Tooltip>
                  </Grid>
                

                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Typography variant="caption" sx={captionTypographyStyles}>
                        {did.no_answer[langIndex]}
                      </Typography>
                      <SelectReact
                        styles={{
                          ...customStylesLocal,
                          groupHeading: (base, props) => {
                            if (props?.data?.label === short.no_answer[langIndex]) {
                              return { ...base, display: 'none', padding: 0, margin: 0, height: 0, minHeight: 0, overflow: 'hidden' }
                            }
                            return {
                              ...base,
                              fontSize: '1rem',
                              fontWeight: 600,
                              lineHeight: '40px',
                              color: '#424242',
                              backgroundColor: '#e8e8e8',
                              padding: '0 12px',
                            }
                          },
                        }}
                        menuPlacement="auto"
                        menuPosition="fixed"
                        onChange={(option) => handleChange('no_action', option ? option.value : '')}
                        menuPortalTarget={document.body}
                        isSearchable={true}
                        value={noActionValueOption}
                        placeholder={input.select[langIndex]}
                        options={noActionGroupedOptions}
                      />
                    </Box>
                  </Grid>

                {(isEdit || isUcomPeer) && shouldShowProfileFields && (
                  <Grid item xs={12}>
                    <Box sx={profileDividerBoxStyles}>
                      <Typography variant="h6" sx={profileSectionTitleStyles}>
                        {did.profile[langIndex]}
                      </Typography>
                    </Box>
                  </Grid>
                )}

                {shouldShowProfileFields && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth size="small" sx={selectStylesLocal}>
                        <InputLabel sx={inputLabelStylesLocal}>{did.profile[langIndex]}</InputLabel>
                        <Select
                          open={profileSelectOpen}
                          onOpen={() => setProfileSelectOpen(true)}
                          onClose={() => setProfileSelectOpen(false)}
                          value={form.profile}
                          onChange={(e) => handleChange('profile', e.target.value)}
                          disabled={isEdit}
                          label={did.profile[langIndex]}
                        >
                          <MenuItem value="">{input.select[langIndex]}</MenuItem>
                          {fixProviders.map(p => (
                            <MenuItem key={p.name} value={p.name}>{p.title}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        size="small"
                        type="number"
                        label={did.line[langIndex]}
                        placeholder={did.line[langIndex]}
                        value={form.line}
                        onChange={(e) => handleChange('line', e.target.value)}
                        onWheel={handleWheel}
                        variant="outlined"
                        sx={inputStylesLocal}
                      />
                    </Grid>
                  </>
                )}

                {shouldShowProfileFields && shouldShowCredentialFields && (
                  <>
                    {showServerHost && (
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          size="small"
                          label={did.server_host[langIndex]}
                          placeholder={did.server_host[langIndex]}
                          value={form.serverHost}
                          onChange={(e) => handleChange('serverHost', e.target.value)}
                          disabled={isEdit}
                          variant="outlined"
                          sx={inputStylesLocal}
                        />
                      </Grid>
                    )}

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label={profile.username[langIndex]}
                        placeholder={profile.username[langIndex]}
                        value={form.username}
                        onChange={(e) => handleChange('username', e.target.value)}
                        disabled={isEdit}
                        variant="outlined"
                        sx={inputStylesLocal}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        size="small"
                        type="password"
                        label={profile.pass[langIndex]}
                        placeholder={profile.pass[langIndex]}
                        value={form.password}
                        onChange={(e) => handleChange('password', e.target.value)}
                        disabled={isEdit}
                        variant="outlined"
                        sx={inputStylesLocal}
                      />
                    </Grid>
                  </>
                )}

                {!shouldShowProfileFields && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      label={did.line[langIndex]}
                      placeholder={did.line[langIndex]}
                      value={form.line}
                      onChange={(e) => handleChange('line', e.target.value)}
                      onWheel={handleWheel}
                      variant="outlined"
                      sx={inputStylesLocal}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>

            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                size="small"
                onClick={handleSave}
                disabled={saving || loading}
                sx={{
                  backgroundColor: primaryColor,
                  color: '#fff',
                  px: 3,
                  py: 0.75,
                  fontSize: '0.875rem',
                  fontWeight: 600,
                  textTransform: 'none',
                  minHeight: '41px',
                  '&:hover': { backgroundColor: hoverColor },
                }}
              >
                {saving ? 'Saving...' : isEdit ? global.edit[langIndex] : sip.add_btn[langIndex]}
              </Button>
            </Box>
          </Paper>
        </Paper>
      </div>
    </Wrapper>
  )
}
